function qas_Categories(state = [], action) {
    switch (action.type) {
        case 'QAS_CATEGORIES/SET':
            return action.qasCategories;
        case 'QAS_CATEGORIES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default qas_Categories;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/qasCategories.js